module.exports = __webpack_public_path__ + "source/img/copy.437c53ee.svg";